<template>
  <div class="home container">
    <img alt="Vue logo" class="img-responsive" src="../assets/logo.png">
    <div class="row">
      <div class="col-12">
        <HelloWorld msg="Vue.js + BoostrapV4 SCSS"/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  }
}
</script>
